import { ArrowRightOutlined, FileImageOutlined, FileOutlined, VideoCameraAddOutlined } from '@ant-design/icons'
import { Avatar, Button, Image, List, Spin, Tooltip } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory } from 'react-router-dom'

import { FileDisplay } from '@/components/file-display'
import { Group, useGetGroupFilesQuery } from '@/generated/graphql'
import { routes } from '@/routes'

import s from './file.module.less'

interface FileContainerProps {
  group: Group
}

export const FileContainer: React.FC<FileContainerProps> = ({ group }) => {
  const { t } = useTranslation()
  const avatarMapping = {
    video: <VideoCameraAddOutlined />,
    image: <FileImageOutlined />,
    file: <FileOutlined />,
  }
  const [isShowPreview, setShowPreview] = React.useState(false)
  const history = useHistory()
  const pageFetchSize = 10
  const { data, loading, fetchMore } = useGetGroupFilesQuery({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    variables: {
      groupId: group.groupId,
      pagination: {
        last: pageFetchSize,
      },
    },
  })

  const files = data ? [...data.group.files.edges].reverse() : []
  const pageInfo = data
    ? data.group.files.pageInfo
    : {
        startCursor: null,
        endCursor: null,
        hasPreviousPage: false,
        hasNextPage: false,
      }

  const fileComponent = files.map(({ node: file }, index) => {
    let type = file.type.split('/')[0]
    type = type !== 'image' && type !== 'video' ? 'file' : type
    const isImage = (type: string) => type.split('/')[0] === 'image'

    return (
      <List.Item key={index} className={s.listItem}>
        <List.Item.Meta
          avatar={<Avatar icon={avatarMapping[type]} />}
          description={
            <div className={s.description}>
              {file.name}
              <Tooltip title={t('post.jumpTo')}>
                <Button shape={'circle'} onClick={() => history.push(routes.posts.page(file.postId!))}>
                  <ArrowRightOutlined />
                </Button>
              </Tooltip>
            </div>
          }
        />
        {isImage(file.type) ? (
          <Image preview={isShowPreview} width='100%' src={file.url} onClick={() => setShowPreview(true)} />
        ) : (
          <FileDisplay height='auto' width='100%' file={file} showDownload />
        )}
      </List.Item>
    )
  })

  const loadingComponent = loading && (
    <div className={s.loading}>
      <Spin delay={300} size='large' />
    </div>
  )

  return (
    <div>
      <InfiniteScroll
        dataLength={fileComponent.length}
        loader={loadingComponent}
        className={s.postList}
        hasMore={pageInfo.hasPreviousPage}
        next={() => {
          fetchMore({
            variables: {
              groupId: group.groupId,
              pagination: {
                last: pageFetchSize,
                before: pageInfo.startCursor,
              },
            },
          })
        }}
      >
        <List>{fileComponent}</List>
      </InfiniteScroll>
    </div>
  )
}
